import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import _ from 'lodash'

import Pagination from './Pagination'
import { dateConverter } from '../helper'
import { fileHistoryConstants } from '../constants/fileHistoryConstants'
import {
  getFileName,
  getFormattedFilePath,
  truncateLongFileName,
  renderLoadingSkeleton,
} from '../helpers/fileHistory'

const FileHistoryTable = ({
  fileType,
  fileHistory,
  sortKey,
  sortOrder,
  sortFileHistory,
  showRecordsFrom,
  setShowRecordsFrom,
  isLoading,
  errorMessage,
}) => {
  if (
    !isLoading &&
    _.has(fileHistory, 'results') &&
    fileHistory.results.length === 0
  )
    return (
      <div className="no-data__msg">
        <div className="ppvx__text--md">
          <Message id="filehistory.no.results" />
        </div>
        <div className="no-data__msg--sub">
          <Message
            id={
              !_.isNull(errorMessage) && errorMessage !== ''
                ? 'filehistory.try.later.message'
                : 'filehistory.try.with.different.time.message'
            }
          />
        </div>
      </div>
    )

  const renderDummyTableBody = (showFileColumn) =>
    Array(fileHistoryConstants.MaxRows)
      .fill()
      .map((_row_i, i) => (
        <tr key={i}>
          {Array(showFileColumn ? 5 : 4)
            .fill()
            .map((_row_j, j) => (
              <td key={j}>{renderLoadingSkeleton()}</td>
            ))}
        </tr>
      ))

  const getTableRowRenderer = (showFileColumn) => {
    const renderTableRow = (row, index) => {
      const timestamp = dateConverter(row.timestamp)
      const status = _.get(row, 'status', false)
      const hasTooltip =
        _.indexOf(['copy', 'move', 'rename'], row.optype) !== -1
      const descPrefix = _.get(
        fileHistoryConstants.OptypeDescPrefixes,
        row.optype,
        '',
      )

      let destFilePath
      if (row.optype === 'rename') destFilePath = getFileName(row.destpath)
      else if (hasTooltip)
        destFilePath = getFormattedFilePath(
          row.destpath.replace(/[\\\/][^\\\/]+$/, ''),
        )

      return (
        <tr key={index}>
          {showFileColumn &&
            (!_.has(row, 'fileName') ? (
              <td />
            ) : (
              <td className="tooltip fileHistoryTooltip cursor-pointer">
                {truncateLongFileName(row.fileName)}
                {row.optype !== 'pull' && (
                  <span className="tooltiptext">
                    {getFormattedFilePath(row.path)}
                  </span>
                )}
              </td>
            ))}
          <td
            className={
              hasTooltip ? 'tooltip fileHistoryTooltip cursor-pointer' : ''
            }
          >
            {row.optype}
            {hasTooltip && (
              <span className="tooltiptext">
                <Message id={`filehistory.${descPrefix}.operation`} />
                &nbsp;{destFilePath}
              </span>
            )}
          </td>
          <td>{_.get(row, 'user', '')}</td>
          <td>{timestamp}</td>
          <td className="text-center">
            {status && (
              <span
                className={`ppvx_badge ppvx_badge--type_${
                  status === 'success' ? 'success' : 'critical'
                }`}
              >
                {status}
              </span>
            )}
          </td>
        </tr>
      )
    }
    return renderTableRow
  }

  const renderTableHeader = (showFileColumn) => (
    <thead>
      <tr>
        {fileHistoryConstants.TableHeadings.map(
          (heading, i) =>
            (heading.label !== 'File' || showFileColumn) && (
              <th
                key={i}
                className="cursor-pointer"
                onClick={() =>
                  isLoading ? null : sortFileHistory(heading.key)
                }
              >
                <div className="flexSpaceBetween">
                  <Message
                    id={`filehistory.table.header.${heading.localizeId}`}
                  />
                  <span className="no-select">
                    <span
                      className={`ppvx_icon ppvx_icon--size_xs ppvx_icon-sort-${sortOrder}-alt sort_icon--${
                        sortKey === heading.key ? 'show' : 'hide'
                      }`}
                    />
                  </span>
                </div>
              </th>
            ),
        )}
      </tr>
    </thead>
  )

  const showFileColumn = fileType === 'folder'
  return (
    <div className="table__container">
      <div>
        <div className="font-weight-bold w-100 text-center">
          <Message id="filehistory.title" />
        </div>
        <table className="w-100" cellSpacing="0">
          {renderTableHeader(showFileColumn)}
          <tbody>
            {isLoading
              ? renderDummyTableBody(showFileColumn)
              : fileHistory.results.map(getTableRowRenderer(showFileColumn))}
          </tbody>
        </table>
      </div>
      {!isLoading && fileHistory.total > fileHistoryConstants.MaxRows && (
        <Pagination
          totalPages={Math.ceil(
            fileHistory.total / fileHistoryConstants.MaxRows,
          )}
          pageNo={showRecordsFrom / fileHistoryConstants.MaxRows + 1}
          onPaginationClick={(pageNo) =>
            setShowRecordsFrom((pageNo - 1) * fileHistoryConstants.MaxRows)
          }
          totalElements={fileHistory.total}
          pageLimit={fileHistoryConstants.MaxRows}
        />
      )}
    </div>
  )
}

export default FileHistoryTable
